module.exports = __webpack_public_path__ + "static/media/obras.07a489a8.jpg";